// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__YA6X3","content":"styles_content__2mZf1","selectAll":"styles_selectAll__2-cp8"};